module.exports = "https://coursera_assets.s3.amazonaws.com/images/56560d805646963306b5dcc18bdb8356.png";